const apiBaseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const appConfig: any = {
  apiConfig: {
    baseURL: apiBaseURL,
  }
};
